import { useTokens } from './theme';

/**
 * CSS spinner replacing RN's <ActivityIndicator>. Theme-aware (track + head
 * colors from the token bag). `size` is the px diameter.
 *
 * @param {{ size?: number, className?: string }} props
 */
export function Spinner({ size = 20, className = '' }) {
  const t = useTokens();
  return (
    <span
      role="status"
      aria-label="Loading"
      className={`inline-block animate-spin rounded-full align-[-0.125em] ${className}`}
      style={{
        width: size,
        height: size,
        borderWidth: Math.max(2, Math.round(size / 10)),
        borderStyle: 'solid',
        borderColor: t.spinnerTrack,
        borderTopColor: t.spinnerHead,
      }}
    />
  );
}

export default Spinner;
